import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { motion } from 'framer-motion';
import AdminSidebar from '../components/admin/AdminSidebar';

const AdminLayout: React.FC = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  // Queue Worker Simplificado no Frontend
  // Mantém a fila rodando enquanto o admin estiver logado e com a aba aberta
  useEffect(() => {
    const processQueue = async () => {
      try {
        // Usa fetch com timeout curto para não bloquear
        await fetch('/api/queue/process', { 
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ source: 'admin_dashboard_worker' })
        });
      } catch (e) {
        // Silencioso
      }
    };

    // Executa imediatamente e depois a cada 30 segundos
    processQueue();
    const interval = setInterval(processQueue, 30000); // 30s interval

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen bg-black text-white flex">
      <AdminSidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
      
      <motion.main 
        initial={false}
        animate={{ 
          marginLeft: isCollapsed ? 80 : 250,
          width: `calc(100% - ${isCollapsed ? 80 : 250}px)` 
        }}
        transition={{ duration: 0.3, type: 'spring', stiffness: 200, damping: 25 }}
        className="flex-1 min-h-screen relative"
      >
        <div className="p-8 max-w-[1600px] mx-auto">
          <Outlet />
        </div>
      </motion.main>
    </div>
  );
};

export default AdminLayout;
